module.exports = __webpack_public_path__ + "img/technology@2x.0f64e5e.webp";